module.exports = __webpack_public_path__ + "img/1080_04.7dbc06a9.jpg";